import React from "react";

import bannerImg from "../../assets/back.png";
import infraImg from "../../assets/3rd.png";
import lastImg from "../../assets/LAST.png";

// icons
import { IoCall, IoMic, IoVolumeHigh } from "react-icons/io5";
import { FaBrain } from "react-icons/fa";

const styles = `
  /* ── HERO ── */
  .conv-hero {
    background-size: cover;
    background-position: center;
    padding: 120px 120px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .conv-hero-left {
    max-width: 600px;
  }

  .conv-hero-tag {
    border: 2px solid #222;
    padding: 6px 20px;
    border-radius: 25px;
    font-weight: 500;
    display: inline-block;
    font-size: 30px;
  }

  .conv-hero-h1 {
    font-family: 'Exo', sans-serif;
    font-size: 60px;
    font-weight: 700;
    line-height: 1.05;
    margin-bottom: 25px;
  }

  .conv-hero-box {
    width: 400px;
    max-width: 100%;
    height: auto;
    min-height: 75px;
    margin-top: 25px;
    padding: 18px 28px;
    border-radius: 22px;
    border: 1.2px solid #000;
    background: rgba(255,255,255,0.55);
    backdrop-filter: blur(8px);
    text-align: center;
    font-family: 'Exo', sans-serif;
    font-size: 15px;
    line-height: 1.7;
    font-weight: 500;
    box-shadow: 5px 8px 18px rgba(0,0,0,0.18);
    box-sizing: border-box;
  }

  .conv-hero-right {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-left: 200px;
    gap: 30px;
  }

  .conv-wave-row {
    display: flex;
    align-items: center;
    gap: 40px;
  }

  .conv-assistant-card {
    display: flex;
    align-items: center;
    gap: 14px;
    background: #fff;
    padding: 16px 22px;
    border-radius: 16px;
    box-shadow: 0 10px 25px rgba(0,0,0,0.15);
    min-width: 360px;
  }

  /* ── ENGINE ── */
  .conv-engine {
    width: 100%;
    min-height: 400px;
    padding: 120px 0;
    background-size: cover;
    background-position: center;
  }

  .conv-engine-inner {
    max-width: 1200px;
    margin: 0 auto;
    text-align: center;
    padding: 0 20px;
    box-sizing: border-box;
  }

  .conv-engine h2 {
    font-size: 52px;
    font-weight: 700;
    font-family: 'Exo', sans-serif;
    text-shadow: 0px 6px 18px rgba(0,0,0,0.35);
    margin-bottom: 10px;
  }

  .conv-flow-row {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 16px;
    flex-wrap: wrap;
  }

  .conv-flow-card {
    width: 160px;
    height: 160px;
    border-radius: 18px;
    border: 2px solid #7a3cff;
    background: rgba(255,255,255,0.9);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    box-shadow: 0 0 22px rgba(122,60,255,0.3);
  }

  /* ── TABLET (max-width: 1024px) ── */
  @media (max-width: 1024px) {
    .conv-hero {
      padding: 80px 60px;
      gap: 40px;
    }

    .conv-hero-h1 {
      font-size: 46px;
    }

    .conv-hero-tag {
      font-size: 22px;
    }

    .conv-hero-right {
      margin-left: 60px;
    }

    .conv-assistant-card {
      min-width: 280px;
    }

    .conv-engine {
      padding: 80px 0;
    }

    .conv-engine h2 {
      font-size: 40px;
    }
  }

  /* ── SMALL TABLET / LANDSCAPE MOBILE (max-width: 768px) ── */
  @media (max-width: 768px) {
    .conv-hero {
      flex-direction: column;
      padding: 60px 30px;
      gap: 50px;
      align-items: flex-start;
    }

    .conv-hero-left {
      max-width: 100%;
    }

    .conv-hero-h1 {
      font-size: 38px;
    }

    .conv-hero-tag {
      font-size: 18px;
      padding: 5px 16px;
    }

    .conv-hero-box {
      width: 100%;
    }

    .conv-hero-right {
      margin-left: 0;
      width: 100%;
    }

    .conv-wave-row {
      gap: 20px;
    }

    .conv-assistant-card {
      min-width: unset;
      width: 100%;
      box-sizing: border-box;
    }

    .conv-engine {
      padding: 60px 0;
    }

    .conv-engine h2 {
      font-size: 32px;
    }

    .conv-flow-card {
      width: 130px;
      height: 130px;
    }
  }

  /* ── PORTRAIT MOBILE (max-width: 480px) ── */
  @media (max-width: 480px) {
    .conv-hero {
      padding: 40px 16px;
      gap: 36px;
    }

    .conv-hero-h1 {
      font-size: 30px;
    }

    .conv-hero-tag {
      font-size: 15px;
      padding: 4px 12px;
    }

    .conv-hero-box {
      font-size: 13px;
      padding: 14px 16px;
      border-radius: 14px;
    }

    .conv-wave-row {
      gap: 10px;
      flex-wrap: wrap;
      justify-content: center;
    }

    .conv-engine {
      padding: 40px 0;
    }

    .conv-engine h2 {
      font-size: 26px;
    }

    .conv-flow-row {
      gap: 10px;
    }

    .conv-flow-card {
      width: 110px;
      height: 110px;
      border-radius: 12px;
    }
  }
`;

function ConversationalAIPage() {
  return (
    <div style={{ fontFamily: "'Exo', sans-serif" }}>
      <style>{styles}</style>

      {/* ================= HERO ================= */}
      <div
        className="conv-hero"
        style={{ backgroundImage: `url(${bannerImg})` }}
      >
        {/* LEFT */}
        <div className="conv-hero-left">
          <div className="conv-hero-tag">Conversational AI</div>

          <h1 className="conv-hero-h1">
            It speaks your <br />
            <span style={{ color: "#7a3cff" }}>language.</span>
          </h1>

          <div className="conv-hero-box">
            Deploy intelligent voice agents that understand the nuances of your
            local culture. Handle thousands of calls simultaneously with zero wait times.
          </div>
        </div>

        {/* RIGHT */}
        <div className="conv-hero-right">
          {/* WAVE */}
          <div className="conv-wave-row">
            {/* LEFT WAVE */}
            <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
              <div style={{ width: "6px", height: "40px", background: "#c4a5ff", borderRadius: "4px" }} />
              <div style={{ width: "6px", height: "60px", background: "#7c3aed", borderRadius: "4px" }} />
              <div style={{ width: "6px", height: "80px", background: "#f59e0b", borderRadius: "4px" }} />
              <div style={{ width: "6px", height: "60px", background: "#7c3aed", borderRadius: "4px" }} />
              <div style={{ width: "6px", height: "40px", background: "#c4a5ff", borderRadius: "4px" }} />
            </div>

            {/* DOTS */}
            <div style={{ display: "flex", gap: "6px" }}>
              <div style={{ width: "6px", height: "6px", background: "#a78bfa", borderRadius: "50%" }} />
              <div style={{ width: "6px", height: "6px", background: "#a78bfa", borderRadius: "50%" }} />
              <div style={{ width: "6px", height: "6px", background: "#a78bfa", borderRadius: "50%" }} />
            </div>

            {/* CENTER WAVE */}
            <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
              <div style={{ width: "6px", height: "60px", background: "#c4a5ff", borderRadius: "4px" }} />
              <div style={{ width: "6px", height: "90px", background: "#7c3aed", borderRadius: "4px" }} />
              <div style={{ width: "6px", height: "120px", background: "#f59e0b", borderRadius: "4px" }} />
              <div style={{ width: "6px", height: "90px", background: "#7c3aed", borderRadius: "4px" }} />
              <div style={{ width: "6px", height: "60px", background: "#c4a5ff", borderRadius: "4px" }} />
            </div>

            {/* DOTS */}
            <div style={{ display: "flex", gap: "6px" }}>
              <div style={{ width: "6px", height: "6px", background: "#a78bfa", borderRadius: "50%" }} />
              <div style={{ width: "6px", height: "6px", background: "#a78bfa", borderRadius: "50%" }} />
              <div style={{ width: "6px", height: "6px", background: "#a78bfa", borderRadius: "50%" }} />
            </div>

            {/* RIGHT WAVE */}
            <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
              <div style={{ width: "6px", height: "40px", background: "#c4a5ff", borderRadius: "4px" }} />
              <div style={{ width: "6px", height: "60px", background: "#7c3aed", borderRadius: "4px" }} />
              <div style={{ width: "6px", height: "80px", background: "#f59e0b", borderRadius: "4px" }} />
              <div style={{ width: "6px", height: "60px", background: "#7c3aed", borderRadius: "4px" }} />
              <div style={{ width: "6px", height: "40px", background: "#c4a5ff", borderRadius: "4px" }} />
            </div>
          </div>

          {/* ASSISTANT CARD */}
          <div className="conv-assistant-card">
            <div
              style={{
                width: "42px",
                height: "42px",
                borderRadius: "50%",
                background: "#eee",
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
              }}
            >
              🎤
            </div>

            <div style={{ flex: 1 }}>
              <div style={{ fontWeight: "600", fontSize: "15px" }}>
                Assistant is speaking...
              </div>
              <div style={{ fontSize: "14px", color: "#555" }}>
                "Welcome to AI Support."
              </div>
            </div>

            <div
              style={{
                background: "#e6f0ff",
                padding: "5px 10px",
                borderRadius: "8px",
                fontSize: "12px"
              }}
            >
              LIVE
            </div>
          </div>
        </div>
      </div>

      <div style={{ width: "100%", height: "30px", background: "#000" }} />

      {/* ================= ENGINE ================= */}
      <div
        className="conv-engine"
        style={{ backgroundImage: `url(${bannerImg})` }}
      >
        <div className="conv-engine-inner">
          <h2>The Conversation Engine</h2>

          <p style={{ color: "#444", fontSize: "16px", marginBottom: "60px" }}>
            How we process voice data in under 400ms to ensure natural flow.
          </p>

          <div className="conv-flow-row">
            {[
              { title: "Ingest",     sub: "SIP Trunking / WebRTC",  icon: <IoCall /> },
              { title: "Transcribe", sub: "Speech-to-Text (STT)",   icon: <IoMic /> },
              { title: "Think",      sub: "LLM Reasoning",          icon: <FaBrain /> },
              { title: "Speak",      sub: "Text-to-Speech (TTS)",   icon: <IoVolumeHigh /> }
            ].map((item, i) => (
              <React.Fragment key={i}>
                <div className="conv-flow-card">
                  <div
                    style={{
                      width: "60px",
                      height: "50px",
                      borderRadius: "50%",
                      background: "#ede9fe",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "22px",
                      color: "#7a3cff",
                      marginBottom: "12px"
                    }}
                  >
                    {item.icon}
                  </div>

                  <h3 style={{ fontSize: "17px", fontWeight: "600", margin: 0 }}>
                    {i + 1}. {item.title}
                  </h3>

                  <p
                    style={{
                      fontSize: "13px",
                      color: "#555",
                      marginTop: "6px",
                      textAlign: "center",
                      padding: "0 10px"
                    }}
                  >
                    {item.sub}
                  </p>
                </div>

                {i !== 3 && (
                  <div style={{ fontSize: "20px", color: "#222" }}>→</div>
                )}
              </React.Fragment>
            ))}
          </div>
        </div>
      </div>

      <div style={{ width: "100%", height: "30px", background: "#000" }} />

      {/* ================= INFRA ================= */}
      <div
        style={{
          backgroundImage: `url(${bannerImg})`,
          backgroundSize: "cover",
          padding: "100px 0",
          textAlign: "center"
        }}
      >
        <img
          src={infraImg}
          alt="Conversational AI infrastructure"
          style={{ width: "100%", marginTop: "50px" }}
        />
      </div>

      <div style={{ width: "100%", height: "30px", background: "#000" }} />

      {/* ================= FINAL ================= */}
      <div
        style={{
          backgroundImage: `url(${bannerImg})`,
          backgroundSize: "cover",
          padding: "100px 0",
          textAlign: "center"
        }}
      >
        <img
          src={lastImg}
          alt=""
          style={{ width: "100%", marginTop: "50px" }}
        />
      </div>
    </div>
  );
}

export default ConversationalAIPage;
